import * as actionTypes from './actionTypes';
import axios from 'axios';

const IDENTITY = process.env.REACT_APP_IDENTITY_API_URL;

export const initState = () => {
    return dispatch => {
        dispatch({
            type: actionTypes.INIT_STATE
        })
    };
};


//get users
export const getUsers = (type) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.GET_ACTIVITY_LIST_LOADING
        })
        let apiUrl = IDENTITY +'/user/activity?state='+type;

        axios.get(apiUrl)
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    dispatch({
                        type: actionTypes.GET_ACTIVITY_LIST_SUCCESS,
                        activity: response.data
                    });
                }
            })
            .catch(error => {
                let errMsg  = error;
                if(error.response && error.response.data.errorMessage){
                    errMsg = error.response.data.errorMessage;
                }
                dispatch({
                    type: actionTypes.GET_ACTIVITY_LIST_ERROR,
                    error: errMsg
                });
            });
    };
}


//Post revoke
export const postRevoke = (data) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.POST_REVOKE_LOADING
        })
        let apiUrl =  IDENTITY+'/revoke';
        axios.post(apiUrl,data)
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                     dispatch({
                        type: actionTypes.POST_REVOKE_SUCCESS,
                        // users: response.data
                    });
                }
            })
            .catch(error => {
                let errMsg  = error;
                if(error.response && error.response.data.errorMessage){
                    errMsg = error.response.data.errorMessage;
                }
                dispatch({
                    type: actionTypes.POST_REVOKE_ERROR,
                    error: errMsg
                });
            });
    };
}
